import RelatedEntityRelationship from "../../../../Global/Models/Related/RelatedEntityRelationship";
import StandingGameModel from "../StandingGameModel";
import StandingGamesModel from "../StandingGamesModel";
import StandingGameMetaModel from "../StandingGameMetaModel";
import StandingGameMetaParticipantsModel from "../StandingGameMetaParticipantsModel";
import StandingGamePredictionModel from "../Prediction/StandingGamePredictionModel";
import StandingGamePredictionsModel from "../StandingGamePredictionsModel";
import StandingGameRankingsModel from "../Rankings/StandingGameRankingsModel";

export default class StandingGameRemapper {
  public remapBracketGames = (response: any) => {
    const model = new StandingGamesModel();

    model.meta.pagination.itemsPerPage =
      response.meta.pagination.items_per_page;
    model.meta.pagination.nextPageStartsAfter =
      response.meta.pagination.next_page_starts_after;
    model.data = response.data.map((d) => this.remapStandingGameById(d));

    return model;
  };

  public remapStandingGameById = (response: any) => {
    const model = new StandingGameModel();

    model.id = response.id;
    model.title = response.title;
    model.description = response.description;
    model.rules = response.rules;
    model.customFields = response.custom_fields;
    model.images = response.images;
    model.type = response.type;
    model.status = response.status;
    model.points = response.points;
    model.related = response.related
      ? this.remapRelated(response.related)
      : response.related;
    model.predictionsCutoff = response.predictions_cutoff;
    model.meta =
      response.meta && response.meta.participants
        ? this.remapStandingGameMeta(response.meta)
        : response.meta;
    model.outcomeCount = response.outcome_count;
    model.outcome = response.outcome;
    model.createdAt = response.created_at;
    model.updatedAt = response.updated_at;

    return model;
  };

  public remapPrediction = (response: any) => {
    const model = new StandingGamePredictionModel();

    model.id = response.id;
    model.profileId = response.profile_id;
    model.gameId = response.game_id;
    model.totalPoints = response.total_points;
    model.gamePoints = response.game_points;
    model.bonusPoints = response.bonus_points;
    model.position = response.position;
    model.status = response.status;
    model.standing = response.standing;
    model.total = response.total;
    model.createdAt = response.created_at;
    model.updatedAt = response.updated_at;

    return model;
  };

  public remapPredictionsForUser = (response: any) => {
    const model = new StandingGamePredictionsModel();

    model.meta.pagination.itemsPerPage =
      response.meta.pagination.items_per_page;
    model.meta.pagination.nextPageStartsAfter =
      response.meta.pagination.next_page_starts_after;
    model.data = response.data.map((d) => this.remapPrediction(d));

    return model;
  };

  public remapRankings = (response: any) => {
    const model = new StandingGameRankingsModel();

    model.meta.pagination.itemsPerPage =
      response.meta.pagination.items_per_page;
    model.meta.pagination.nextPageStartsAfter =
      response.meta.pagination.next_page_starts_after;
    model.data = response.data.map((d) => this.remapPrediction(d));

    return model;
  };

  private remapRelated = (response: any[]) => {
    return response.map((r) => {
      const model = new RelatedEntityRelationship();

      model.entityId = r.entity_id;
      model.entityType = r.entity_type;
      model.entityRelationship = r.entity_relationship;

      return model;
    });
  };

  private remapStandingGameMeta = (response: any) => {
    const model = new StandingGameMetaModel();

    model.participants = response.participants.map((p: any) => {
      const model = new StandingGameMetaParticipantsModel();

      model.id = p.id;
      model.name = p.name;
      model.group = p.group;
      model.image = p.image;
      model.undecided = p.undecided;

      return model;
    });

    return model;
  };
}
